import { useCallback, useContext } from 'react';
import type { PropsWithChildren } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import type { ProviderList } from './types';
import { ComposeProviders } from './ComposeProviders';
import { ErrorHandler } from '../containers';
import { QueryProvider } from './QueryProvider';
import { ThemeProvider } from './ThemeProvider';
import { LoggerContext } from './LoggerProvider';

type CoreProviderProps = PropsWithChildren<unknown>;

const providers: ProviderList = [
  [
    function WithLogger(props) {
      const loggerService = useContext(LoggerContext);
      const onError = useCallback((error: unknown) => loggerService.error(error), [loggerService]);

      return <ErrorHandler onError={onError} {...props} />;
    },
  ],
  [HelmetProvider],
  QueryProvider,
  [ThemeProvider],
];

export function CoreProviders({ children }: CoreProviderProps) {
  return <ComposeProviders providers={providers}>{children}</ComposeProviders>;
}
